import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { CognitoCallback, LoggedInCallback, UserLoginService, UserParametersService } from '../service/cognito.service';
import { User } from '../index';
import { GlobalEventsManager } from '../../app-global-events-manager';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements CognitoCallback, LoggedInCallback, OnInit {

  invalidCredentialMsg: string;
  user: any = {
    username: '',
    password: ''
  };
  loaderActivate: boolean;
  constructor(private authService: AuthService, private globalEventsManager: GlobalEventsManager,
    private router: Router, public userService: UserLoginService,
    public userParameterService: UserParametersService , private translate: TranslateService) {
    this.invalidCredentialMsg = null;
    this.globalEventsManager.showNavBarSeller(false);
    this.globalEventsManager.showNavBarWorker(false);
    this.globalEventsManager.showNavBar(false);
  }

  onFormSubmit(model: any, isValid: boolean) {
     if (!isValid) {
      return;
    }
    this.invalidCredentialMsg = null;
    this.loaderActivate = true;
    this.userService.authenticate(this.user.username, this.user.password, this);

  }

  ngOnInit() {
    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)) {
      this.router.navigate(['/mobileview']);
    } else {
      this.invalidCredentialMsg = null;
      this.globalEventsManager.showNavBarSeller(false);
      this.globalEventsManager.showNavBarWorker(false);
      this.globalEventsManager.showNavBar(false);
      console.log('Checking if the user is already authenticated. If so, then redirect to the secure site');
      this.userService.isAuthenticated(this);
    }
  }

  cognitoCallback(message: string, result: any) {
    if (message != null) { // error
      console.log('result: ' + this.invalidCredentialMsg);
      if (message === 'User does not exist.') {
        this.translate.get('ForgotPassword.Userdeoesnotexits').subscribe(error => {
          this.invalidCredentialMsg = error;
        });
        this.loaderActivate = false;
        return;
      }
      this.invalidCredentialMsg = message;
      if (this.invalidCredentialMsg === 'User is not confirmed.') {
        this.router.navigate(['/confirmverificationcode']);
      }
      this.loaderActivate = false;
    } else { // success
      this.authService.getLoggedInUser().then(returnObj => {
        if (returnObj != null) {
          this.globalEventsManager.showNavBarRoleName(returnObj.role.toLowerCase());
          if (returnObj.role.toLowerCase() === 'worker' || returnObj.role.toLowerCase() === 'sub_supplier') {
            this.globalEventsManager.showNavBarSeller(false);
            this.globalEventsManager.showNavBarWorker(true);
            this.globalEventsManager.showNavBar(true);
            this.globalEventsManager.sendNotificationWorkerName('');
            this.router.navigate(['/worker/safetybox']);
          } else {
            this.globalEventsManager.showNavBarSeller(true);
            this.globalEventsManager.showNavBarWorker(false);
            this.globalEventsManager.showNavBar(true);
            this.globalEventsManager.sendNotificationSellerName('');
            this.globalEventsManager.sendHeaderActivate('profile');
            this.router.navigate(['/seller/profile']);
          }
        }
        this.loaderActivate = false;
      });
    }
  }

  // callbackWithParam(result: any): void {
  //   console.log(result);
  //   if (result.lenth > 0) {
  //     // tslint:disable-next-line:prefer-const
  //     let roleObj = result.map(function (ite) {
  //       if (ite.Name === 'custom:role') {
  //         return ite;
  //       }
  //     });

  //     if (roleObj != null) {
  //       if (roleObj === 'worker') {
  //         this.globalEventsManager.showNavBar(false);
  //         this.router.navigate(['/worker/dashboard']);
  //       } else {
  //         this.globalEventsManager.showNavBar(true);
  //         this.router.navigate(['/seller/profile']);
  //       }
  //     }


  //   }
  // }



  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (isLoggedIn) {
      this.globalEventsManager.showNavBar(true);
      this.router.navigate(['/seller/profile']);
    }
  }
  goToRegistration(): void {
    this.router.navigate(['/registration']);
  }

  goToForgetPassword(): void {
    this.router.navigate(['/login/forgetpassword']);
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/login/login.component.ts